import { CompanyApi, UserApi } from "@/api-v2/settings-storage/api";
import { settingStorageApi } from "@/getinfo-api/index";

interface CompanySettings {
  getStudentLimit(companyId: string): Promise<number>;
  setStudentLimit(
    companyId: string,
    amount: number
  ): Promise<{ amount: number }>;
  getIsFinishLearningWithEndLr(
    companyId: string
  ): Promise<{ isFinish: boolean }>;
  setIsFinishLearningWithEndLr(
    companyId: string,
    isFinish: boolean
  ): Promise<{ isFinish: boolean }>;
}
interface UserSettings {
  getUserCompany(userId: string): Promise<{ companyId: string | null }>;
  setUserCompany(
    userId: string,
    companyId: string
  ): Promise<{ companyId: string }>;
}

class ApiCompanySettings implements CompanySettings {
  private readonly STUDENTS_LIMIT = "studentLimit";
  private readonly FINISH_LEARNING_WITH_LR_END_STATUS =
    "finishLearningWithLrEndStatus";
  private api: CompanyApi;

  constructor(api: CompanyApi) {
    this.api = api;
  }

  async getStudentLimit(companyId: string): Promise<number> {
    const { data } = await this.api.getCompanySettings(companyId, [
      this.STUDENTS_LIMIT
    ]);

    if (data.length && "amount" in data[0].value) {
      //@ts-ignore
      let limit = data[0].value.amount as number;
      return +limit;
    } else {
      let limit = await this.setStudentLimit(companyId, 0);
      return limit.amount;
    }
  }

  async setStudentLimit(
    companyId: string,
    amount: number
  ): Promise<{ amount: number }> {
    const { data } = await this.api.putCompanySettings(companyId, [
      { name: this.STUDENTS_LIMIT, value: { amount: amount } }
    ]);

    return data[0].value as { amount: number };
  }

  async getIsFinishLearningWithEndLr(
    companyId: string
  ): Promise<{ isFinish: boolean }> {
    const { data } = await this.api.getCompanySettings(companyId, [
      this.FINISH_LEARNING_WITH_LR_END_STATUS
    ]);

    if (data.length && "isFinish" in data[0].value) {
      //@ts-ignore
      return data[0].value;
    } else {
      return await this.setIsFinishLearningWithEndLr(companyId, false);
    }
  }

  async setIsFinishLearningWithEndLr(
    companyId: string,
    isFinish: boolean
  ): Promise<{ isFinish: boolean }> {
    const { data } = await this.api.putCompanySettings(companyId, [
      {
        name: this.FINISH_LEARNING_WITH_LR_END_STATUS,
        value: { isFinish: isFinish }
      }
    ]);

    return data[0].value as { isFinish: boolean };
  }
}

class ApiUserSettings implements UserSettings {
  private readonly USER_COMPANY = "userCompany";
  private api: UserApi;

  constructor(api: UserApi) {
    this.api = api;
  }

  async getUserCompany(userId: string): Promise<{ companyId: string | null }> {
    const { data } = await this.api.getUserSettings(userId, [
      this.USER_COMPANY
    ]);

    if (data.length && "companyId" in data[0].value) {
      return data[0].value as { companyId: string };
    } else {
      return { companyId: null };
    }
  }

  async setUserCompany(
    userId: string,
    companyId: string
  ): Promise<{ companyId: string }> {
    const { data } = await this.api.putUserSettings(userId, [
      { name: this.USER_COMPANY, value: { companyId: companyId } }
    ]);

    return data[0].value as { companyId: string };
  }
}
export const settingStorageLocalApi = Object.freeze({
  Company: new ApiCompanySettings(settingStorageApi.Company),
  User: new ApiUserSettings(settingStorageApi.User)
});
